import type { Maintenance503Payload } from '@/types/maintenanceApiTypes';

export function isMaintenance503Payload(value: unknown): value is Maintenance503Payload {
  return (
    typeof value === 'object' &&
    value !== null &&
    'maintenance_start_label' in value &&
    'maintenance_end_label' in value &&
    typeof (value as Maintenance503Payload).maintenance_start_label === 'string' &&
    typeof (value as Maintenance503Payload).maintenance_end_label === 'string'
  );
}
